import React, { Suspense, lazy, useEffect } from 'react';
import Subhero from "../subhero/Subhero";
import { Helmet } from "react-helmet";
import Placeholder from '../generic/Placeholder'

const ContactForm = lazy(() => import("../contact-form/ContactForm"))

const PageMailwallBookademo = () => {
    return (
        <>
            <Helmet>
                <title>Mailwall - Advanced Email Security Made Simple</title>
                <meta name="description" content="Mailwall - advanced email filtering services for business. See how Omniquad's email protection can meet all your online security needs."/>
            </Helmet>
            <main className={"Page"}>
                <Subhero>
                    <div className="main-title">Secure your entire organization from known, unknown and emerging threats - including email fraud- with Omniquad's comprehensive, cloud-based email security platform. Book a free demonstration with an expert ask any questions.</div>
                </Subhero>
            </main>
            <Suspense fallback={<Placeholder />}>
                <ContactForm variant={"mailwall"} hideform={"true"} />
            </Suspense>
        </>
    )
}

export default PageMailwallBookademo;